function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.88808 16.3957L3.88701 16.3964C3.70013 16.5059 3.40185 16.5349 3.14273 16.4537C3.0773 16.4332 3.03078 16.4105 3 16.3922V5.10829C3.03083 5.08989 3.07747 5.06711 3.1431 5.04652C3.40253 4.96513 3.70114 4.99394 3.88808 5.10317C3.8881 5.10318 3.88812 5.1032 3.88814 5.10321L13.5466 10.7495L3.88808 16.3957Z",
  stroke: "white",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.25,
  cy: 10.75,
  r: 5.75,
  stroke: "white",
  strokeWidth: 2
});
function SvgTvadCrossChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvadCrossChannelIcon);
export default __webpack_public_path__ + "static/media/TVAD Cross Channel Icon.0e9132f0a20ac32b2218c4900756da3a.svg";
export { ForwardRef as ReactComponent };